<template>
  <v-layout align-center justify-center row fill-height class="ma-0 grey lighten-1">
    <v-card>
      <v-card-title>
        <h2 class="text-h4">Log in Error</h2>
      </v-card-title>
      <v-card-text>
        <p class="text-xs-center">There was a problem logging you in. Please try again shortly.</p>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="logOut()" text>
          Logout
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="retry()" text class="success">
          Retry
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script lang="ts">

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import { Component, Prop, Vue } from 'vue-property-decorator';

import auth from '@/services/auth';

@Component({})
export default class LoginError extends Vue {
    private retry(): void {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;

      auth.processLogin().then(
        () => {
          // Redirect to the default page 
          that.$router.push({
            path: "/"
          });
        },
        () => {
          that.$router.push({
            path: "/loginerror"
          });
        }
      );
    }

    private logOut(): void {
      this.$router.push({
        path: "/logout"
      });
    }
}
</script>